module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "ORIM-Dedication",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_vm._v("For my grandsons in the future Laurence and Thomas")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication"
  }, [_vm._v("(Thomas who was the first person to read this discourse)")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication"
  }, [_vm._v("And to Jason and Max and Ben")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication"
  }, [_vm._v("and of course Archie with my love. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c64cb9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FinchesofMars_1P2.vue
// module id = 69
// module chunks = 0